//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';


//local imports
import { DepartmentModel } from '@app/catalog';
import { PresenterType } from '@app/shared';

@PresenterType({
  model: DepartmentModel,
  key: 'tileTop'
})
@Component({
  selector: 'department-carousel-item',
  templateUrl: './department-carousel-item.component.html',
  styleUrl: './department-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DepartmentCarouselItemComponent {
  public data: WritableSignal<DepartmentModel> = signal<DepartmentModel>(undefined);
}
